import { Columns3, List, Rows3 } from 'lucide-react';
import { Button } from '@/components/ui/button';
import {
  SCENE_LIST_VIEW_LIST,
  SCENE_LIST_VIEW_REEL_HORIZONTAL,
  SCENE_LIST_VIEW_REEL_VERTICAL,
} from '@/lib/sceneListViewMode';

const VIEW_OPTIONS = [
  {
    id: SCENE_LIST_VIEW_LIST,
    label: 'List',
    shortLabel: 'List',
    icon: List,
    testId: 'scene-list-view-list',
  },
  {
    id: SCENE_LIST_VIEW_REEL_HORIZONTAL,
    label: 'Horizontal reel',
    shortLabel: 'Reel H',
    icon: Rows3,
    testId: 'scene-list-view-reel-horizontal',
  },
  {
    id: SCENE_LIST_VIEW_REEL_VERTICAL,
    label: 'Vertical reel',
    shortLabel: 'Reel V',
    icon: Columns3,
    testId: 'scene-list-view-reel-vertical',
  },
];

export function SceneListViewToggle({
  value,
  onChange,
  compact = false,
  className = '',
  dark = false,
}) {
  return (
    <div
      className={`inline-flex flex-wrap gap-1 ${className}`.trim()}
      role="group"
      aria-label="Scene list view"
      data-testid="scene-list-view-toggle"
    >
      {VIEW_OPTIONS.map(({ id, label, shortLabel, icon: Icon, testId }) => {
        const active = value === id;
        return (
          <Button
            key={id}
            type="button"
            size="sm"
            variant={active ? 'default' : 'outline'}
            className={`h-7 px-2 text-[10px] gap-1 ${
              dark && !active
                ? 'border-white/15 text-slate-200 hover:bg-white/10'
                : ''
            }`}
            onClick={() => onChange?.(id)}
            aria-pressed={active}
            title={label}
            data-testid={testId}
          >
            <Icon className="w-3.5 h-3.5" />
            {compact ? shortLabel : label}
          </Button>
        );
      })}
    </div>
  );
}
